<template>
  <div class="Ftim-box">
    <div class="Ftim-bt">
      <span>至德-</span>经济
      <i></i>
    </div>

    <div class="">
      <div class="Ftim-top">
        <div class="Ftim-current">
          <em></em>当前位置：<span
            ><router-link :to="{ path: '/' }">首页</router-link> -- </span
          >至德经济
        </div>

        <!-- <div class="Ftim-fanhui">
          <router-link to="/">
            <img src="../../../public/images/fanhui.png" />
          </router-link>
        </div> -->
      </div>
    </div>

    <div class="Whole-tab">
      <span
        v-for="(item, index) in tablist"
        :class="avice == item.id ? 'on' : ''"
        :key="index"
        @click="Tab(item.id)"
        >{{ item.title }}</span
      >
    </div>

    <div class="Ftim-cent" v-if="avice == 1">
      <router-link
        :to="{ path: '/enterinfo', query: { id: item.id,num:ishuoqu,tab:avice } }"
        class="Firmever"
        v-for="(item, index) in infolist"
        :key="index"
        v-if="item.company_info != null"
      >
        <img :src="item.company_info.logo" />
      </router-link>
    </div>

    <div class="Ftim-cent" v-if="avice == 2 || avice == 3">
      <router-link
        :to="{ path: '/econinfo', query: { id: item.id,num:ishuoqu,tab:avice} }"
        class="Ftim-list"
        v-for="(item, index) in infolist"
        :key="index"
      >
        <img :src="item.cover" />
        <div class="Ftim-name">{{ item.title }}</div>
        <div class="Ftim-time">{{ item.created_at }}</div>
      </router-link>
    </div>

    <div class="Ftim-cent mt30" v-if="avice == 4">
      <el-table
        :data="infolist"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        :cell-style="{ 'text-align': 'left', fontSize: '16px', color: '#333' }"
      >
        <!-- <el-table-column prop="company.company_name" label="企业名称" /> -->
        <el-table-column prop="companyName" label="企业名称">
          <template slot-scope="scope">
            至德经济股份有限公司
          </template>
        </el-table-column>
        <el-table-column prop="goods_name" label="采购产品"> </el-table-column>
        <el-table-column prop="goods_spec" label="采购规格"> </el-table-column>
        <el-table-column prop="goods_num" label="采购数量" width="180">
        </el-table-column>
        <el-table-column prop="created_at" label="发布时间" width="180">
        </el-table-column>
      </el-table>
    </div>

    <div class="Ftim-cent mt30" v-if="avice == 5">
      <el-table
        :data="infolist"
        style="width: 100%; font-size: 16px; color: #333"
        :header-cell-style="tableHeaderColor"
        :cell-style="{ 'text-align': 'left' }"
      >
        <!-- <el-table-column prop="company.company_name" label="企业名称" /> -->
        <el-table-column prop="companyName" label="企业名称">
          <template slot-scope="scope">
            至德经济股份有限公司
          </template>
        </el-table-column>
        <el-table-column prop="name" label="招标内容"> </el-table-column>
        <el-table-column prop="start_time" label="开始时间" width="180">
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" width="180">
        </el-table-column>
      </el-table>
    </div>

    <div class="Ftim-more" @click="More" v-if="isgoto">加载更多</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      token: localStorage.pctoken,
      companyName: '你好',
      tablist: [
        {
          title: "企业长廊",
          id: 1,
        },
        {
          title: "经济新闻",
          id: 2,
        },
        {
          title: "经济分析",
          id: 3,
        },
        {
          title: "采购信息",
          id: 4,
        },
        {
          title: "招标信息",
          id: 5,
        },
      ],
      avice: '',
      ishuoqu: 1,
      infolist: [],
      page: 1, //当前页码
      isgoto: false, //是否显示加载更多
    };
  },
  created() {
    this.$layer.loading();
    if (!localStorage.user) {
      this.$confirm("请登录后查看，是否登录", "提示", {
        confirmButtonText: "登录",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ name: "login" });
        })
        .catch(() => {
          this.$router.push({ name: "Index" });
        });
    } else if (
      JSON.parse(localStorage.user).company_id == null ||
      JSON.parse(localStorage.user).company_id == 0
    ) {
      this.$confirm("请认证后查看，是否去认证", "提示", {
        confirmButtonText: "认证",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ name: "Agreement" });
        })
        .catch(() => {
          this.$router.push({ name: "Index" });
        });
    } else if (
      JSON.parse(localStorage.user).company_id != null ||
      JSON.parse(localStorage.user).company_id != 0
    ) {
      this.$http
        .post(
          "/check/company_status",
          {
            company_id: JSON.parse(localStorage.user).company_id,
          },
          {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          }
        )
        .then((response) => {
          this.$layer.closeAll("loading");
          if (response.data.code == 200) {
            if (response.data.data == 1) {
              this.$layer.msg("正在审核中，请稍后查看");
              setTimeout(() => {
                this.$router.push({ name: "Index" });
              }, 1800);
            } else if (response.data.data == 2) {
              this.$confirm("认证未通过，是否重新认证", "提示", {
                confirmButtonText: "认证",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.$router.push({ name: "Agreement" });
                })
                .catch(() => {
                  this.$router.push({ name: "Index" });
                });
            } else {
              if(this.$route.query.tab == undefined){
                this.avice = 1;
                this.$router.push({
                  path:'/economic',
                  query:{
                    tab: this.avice
                  }
                })
              }else{
                this.avice = this.$route.query.tab;
              }
              if (this.avice == 1) {
                this.getData();
              } else if (this.avice == 2) {
                this.getNew();
              } else if (this.avice == 3) {
                this.getFen();
              }
            }
          }
        });
    }
  },
  mounted() {},
  methods: {
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #F2F2F2; color: #999;font-weight: bold; font-size: 16px; text-align:left";
      }
    },
    //获取企业长廊列表数据
    getData() {
      this.$layer.loading();
      this.$http.get("company?page=" + this.page).then((res) => {
        if (res.data.code == 200) {
          this.$layer.closeAll("loading");
          this.infolist = this.infolist.concat(res.data.data.data);
          if (res.data.data.next_page_url != null) {
            this.isgoto = true;
            this.page += 1;
          } else {
            this.isgoto = false;
          }
        } else {
          this.$layer.msg(res.data.message);
        }
      });
    },

    //获取经济新闻列表数据
    getNew() {
      this.$layer.loading();
      this.$http.get("article/5?page=" + this.page).then((res) => {
        if (res.data.code == 200) {
          this.$layer.closeAll("loading");
          this.infolist = this.infolist.concat(res.data.data.data);
          if (res.data.data.next_page_url != null) {
            this.isgoto = true;
            this.page += 1;
          } else {
            this.isgoto = false;
          }
        } else {
          this.$layer.msg(res.data.message);
        }
      });
    },

    //获取经济分析列表数据
    getFen() {
      this.$layer.loading();
      this.$http.get("article/6?page=" + this.page).then((res) => {
        if (res.data.code == 200) {
          this.$layer.closeAll("loading");
          this.infolist = this.infolist.concat(res.data.data.data);
          if (res.data.data.next_page_url != null) {
            this.isgoto = true;
            this.page += 1;
          } else {
            this.isgoto = false;
          }
        } else {
          this.$layer.msg(res.data.message);
        }
      });
    },

    //获取采购列表数据
    getCai() {
      this.$layer.loading();
      this.$http.get("goods?page=" + this.page).then((res) => {
        if (res.data.code == 200) {
          this.$layer.closeAll("loading");
          this.infolist = this.infolist.concat(res.data.data.data);
          if (res.data.data.next_page_url != null) {
            this.isgoto = true;
            this.page += 1;
          } else {
            this.isgoto = false;
          }
        } else {
          this.$layer.msg(res.data.message);
        }
      });
    },

    //获取招标列表数据
    getBiao() {
      this.$layer.loading();
      this.$http.get("engineering?page=" + this.page).then((res) => {
        if (res.data.code == 200) {
          this.$layer.closeAll("loading");
          this.infolist = this.infolist.concat(res.data.data.data);
          if (res.data.data.next_page_url != null) {
            this.isgoto = true;
            this.page += 1;
          } else {
            this.isgoto = false;
          }
        } else {
          this.$layer.msg(res.data.message);
        }
      });
    },

    //切换
    Tab(id) {
      if (this.avice != id) {
        this.$router.push({
          path:'/economic',
          query:{
            tab:id
          }
        })
        this.avice = id;
        this.page = 1;
        this.infolist = [];
        this.$layer.loading();
        if (this.avice == 1) {
          this.getData();
        } else if (this.avice == 2) {
          this.getNew();
        } else if (this.avice == 3) {
          this.getFen();
        } else if (this.avice == 4) {
          this.getCai();
        } else if (this.avice == 5) {
          this.getBiao();
        }
      } else {
        this.$layer.msg(res.data.message);
      }
    },

    //加载更多
    More() {
      if (this.avice == 1) {
        this.getData();
      } else if (this.avice == 2) {
        this.getNew();
      } else if (this.avice == 3) {
        this.getFen();
      } else if (this.avice == 4) {
        this.getCai();
      } else if (this.avice == 5) {
        this.getBiao();
      }
    },
  },
};
</script>
<style scoped>
.Ftim-box {
  background: url(../../../public/images/dysjbjt.png) top no-repeat;
  margin-bottom: 60px;
}
.Ftim-bt {
  width: 1200px;
  margin: 72px auto 0;
  font-weight: bold;
  font-size: 48px;
  color: #333;
  line-height: 48px;
}
.Ftim-bt span {
  color: #d71e1c;
}
.Ftim-bt i {
  display: block;
  width: 48px;
  height: 4px;
  background: #d71e1c;
  margin-top: 30px;
}
.Ftim-top {
  width: 1240px;
  height: 74px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-radius: 20px 20px 0px 0px;
  margin: 74px auto 0;
}
.Ftim-current {
  line-height: 74px;
  font-size: 16px;
  color: #333;
}
.Ftim-current em {
  display: inline-block;
  width: 12px;
  height: 12px;
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%), #d8d8d8;
  border-radius: 50%;
  margin: 0 10px 0 20px;
}
.Ftim-current span {
  color: #999;
}
.Ftim-current a {
  color: #999;
}
.Ftim-fanhui {
  width: 20px;
  height: 20px;
  margin-right: 30px;
}
.Whole-tab {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.Whole-tab span {
  padding: 0px 20px;
  background: #f2f2f2;
  border-radius: 18px;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  text-align: center;
  line-height: 36px;
  margin-right: 15px;
  cursor: pointer;
}
.Whole-tab span.on {
  background: linear-gradient(139deg, #ed403c 0%, #d71e1c 100%);
  color: #fff;
}
.Ftim-cent {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.Ftim-list {
  width: 285px;
  display: block;
  margin-top: 30px;
  margin-right: 0;
}
.Ftim-list:not(:nth-child(4n)) {
  margin-right: 20px;
}
.Ftim-list img {
  width: 285px;
  height: 207px;
  border-radius: 12px;
}
.Ftim-name {
  font-size: 18px;
  color: #333333;
  line-height: 28px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 5px;
}
.Ftim-time {
  font-size: 16px;
  color: #d8d8d8;
  margin-top: 10px;
}
.Ftim-more {
  width: 180px;
  height: 36px;
  background: #f2f2f2;
  border-radius: 18px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 36px;
  text-align: center;
  margin: 40px auto 0;
  cursor: pointer;
}
.Firmever {
  width: 222px;
  height: 222px;
  border-radius: 12px;
  border: 1px solid #d8d8d8;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
}
.Firmever:nth-child(1),
.Firmever:nth-child(6) {
  margin-left: 0;
}
.Firmever img {
  max-width: 208px;
  max-height: 142px;
  object-fit: contain;
}
.mt30 {
  margin-top: 30px;
}
::v-deep .el-table .el-table__cell {
  padding: 20px 0;
}
</style>